


import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { useAuth } from "../App";

export default function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const navigate = useNavigate();
  const { axiosInstance } = useAuth();

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [expired, setExpired] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      toast.error("Les mots de passe ne correspondent pas.");
      return;
    }
    setLoading(true);
    try {
      await axiosInstance.post("/auth/reset-password", {
        token,
        new_password: newPassword,
      });
      toast.success("Mot de passe réinitialisé avec succès.");
      navigate("/login");
    } catch (err) {
      const detail = err.response?.data?.detail || "Erreur inconnue";

      if (
        typeof detail === "string" &&
        (detail.includes("Token invalide") || detail.includes("Token expiré"))
      ) {
        setExpired(true);
      } else {
        toast.error(detail);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!token) {
      toast.error("Token manquant dans l'URL.");
      navigate("/forgot-password");
    }
  }, [token, navigate]);

  if (expired) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-amber-50 p-4">
        <p className="mb-4 text-center text-red-600 font-semibold">
          Le lien de réinitialisation est invalide ou a expiré.
        </p>
        <Button onClick={() => navigate("/forgot-password")}>
          Demander un nouveau lien
        </Button>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-amber-50 p-4">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-md w-full max-w-md space-y-4"
      >
        <h2 className="text-2xl text-amber-800 font-bold text-center mb-4">
          Réinitialiser le mot de passe
        </h2>
        <div>
          <Label>Mot de passe</Label>
          <Input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
            placeholder="Nouveau mot de passe"
          />
        </div>
        <div>
          <Label>Confirmez le mot de passe</Label>
          <Input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
            placeholder="Confirmez le mot de passe"
          />
        </div>
        <Button type="submit" disabled={loading} className="w-full">
          {loading ? "Réinitialisation..." : "Réinitialiser"}
        </Button>
      </form>
    </div>
  );
}
